<template>
<div class="dropdown">
	<!-- <a class="nav-link dropdown-toggle notifications-toggle" :class="{ 'unread': isHasUnread }" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
		<div class="notifications-icon" :data-unread="unreadDisplay">
			<i class="material-icons md-36" :class="{ 'ring': isRinging }">notifications</i>
		</div>
		<div class="label ml-2">{{ $t('Notifications') }}</div>
	</a> -->
	<!-- :class="{
		'btn o-lg' : isAdminNav,
		'btn o-lg': !isAdminNav,
	}" -->
	<div class="nav-link notifications-toggle" :class="{ 'unread': isHasUnread }">
		<button
			class="btn 0-lg btn-main-nav"
			data-toggle="dropdown"
			aria-haspopup="true"
			aria-expanded="false"
		>
			<div class="notifications-icon" :data-unread="unreadDisplay">
				<i class="bi-bell-fill text-primary"></i>
			</div>
		</button>
		<span class="label ml-2 align-self-center" :class="{
			'd-lg-none' : !isAdminNav,
			'd-none' : isAdminNav,
		}">{{ $t('Notifications') }}</span>
		<div class="dropdown-menu hidden"></div> <!-- to solve setAttribute error -->
	</div>
	<div class="notifications-wrapper dropdown-menu dropdown-menu-right">
		<div class="notifications-actions d-flex justify-content-around">
			<div role="button" class="" :class="{'active' : activeTab === 'product'}" @click="switchTab('product')">Product
				<span>
					<span class="ml-1" v-if="unreadProductCount > 0">
						({{ unreadProductCount }})
					</span>
					<span class="unread-dot"  v-if="unreadProductCount > 0"></span>
				</span>
			</div>
			<div role="button" class="" :class="{'active' : activeTab === 'general'}" @click="switchTab('general')">General
				<span>
					<span class="ml-1" v-if="unreadGeneralCount > 0">
						({{ unreadGeneralCount }})
					</span>
					<span class="unread-dot"  v-if="unreadGeneralCount > 0"></span>
				</span>
			</div>
		</div>
		<div class="notifications-list" @scroll="handleScroll">
			<notification
				v-for="(notification, index) in notificationsHeader"
				:key="index"
				:item="notification"
			>
			</notification>
			<notification
				v-if="notificationsHeader.length === 0"
				:item="emptyNotification">
			</notification>
			<div class="notification-loader is-loading" v-if="isFetching"></div>
		</div>
		<div class="notifications-footer">
			<a href="#" @click="onMarkAllAsRead">{{ $t('Mark All as Read') }}</a>
			<router-link :to="notificationLink">
				<div>{{ $t('All Notifications') }}</div>
			</router-link>
		</div>
	</div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Notification from './Notification.vue';
import {
	notifSound,
	coinSound,
	withdrawSound,
	billingPaymentSound,
	NOTIFICATION_TITLES,
	NOTIFICATION_TYPES,
} from '@/lib/statics';
import {
	delay,
	showNotif,
	getNotifMessage,
	getNotifLink,
} from '../lib/helper';

export default {
	name: 'GeneralNotifications',
	components: {
		Notification,
	},
	props: {
		isAdminNav: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			limit: 10,
			sortBy: 'created_at',
			sort: 'desc',
			page: 1,
			emptyNotification: {
				type: 'empty',
				seen: true,
			},
			isRinging: false,
			isAll: false,
		};
	},
	sockets: {
		notification_add(notification) {
			const isGeneral = notification.type && notification.type !== 'logistic';
			if (isGeneral) {
				this.add(notification);
				this.showNotif(notification);
			}
		},
		notification_update(notification) {
			this.update(notification);
		},
		export_update() {
			this.$notify({
				group: 'app',
				type: 'success',
				title: '<a class="disabled-style-link text-white" href="/admin/export-page">Export file completed<a/>',
				text: '<a class="disabled-style-link text-white" href="/admin/export-page">Click for more details</a>',
				duration: 15000,
			});
		},
	},
	methods: {
		...mapActions({
			getNotifications: 'notifications/getNotifications',
			setActiveTab: 'notifications/setActiveTab',
			setNotifications: 'notifications/setNotifications',
			decreaseUnreadProductNotification: 'notifications/decreaseUnreadProductNotification',
			decreaseUnreadGeneralNotification: 'notifications/decreaseUnreadGeneralNotification',
			increaseUnreadProductNotification: 'notifications/increaseUnreadProductNotification',
			increaseUnreadGeneralNotification: 'notifications/increaseUnreadGeneralNotification',
			markAsRead: 'notifications/markAsRead',
			unshiftNewNotification: 'notifications/unshiftNewNotification',
		}),
		fetchNotifications(reset = false) {
			const params = {
				limit: this.limit,
				sort_by: this.sortBy,
				sort: this.sort,
				page: this.page,
			};

			if (this.activeTab === 'product') {
				params.type = 'product';
			} else {
				params.type = 'general';
			}

			const data = {
				params,
				reset,
			};

			this.getNotifications(data);
		},
		handleScroll(event) {
			const elem = event.target;
			const height = elem.offsetHeight;
			const scrollTop = elem.scrollTop;
			const scrollHeight = elem.scrollHeight;
			const offset = 10;
			const isOnBottom = (scrollTop + height + offset) >= scrollHeight;
			if (isOnBottom && !this.isAll && !this.isFetching) {
				// this.fetchNotifications();
			}
		},
		onMarkAllAsRead(event) {
			event.preventDefault();
			this.markAsRead();
		},
		add(notification) {
			const type = notification.type;
			const isProductType = type.substring(0, 7);
			const index = this.notifications.findIndex(currNotification => currNotification._id === notification._id);
			if (index === -1) {
				if (this.activeTab === 'product' && isProductType === 'product') {
					this.unshiftNewNotification(notification);
					this.increaseUnreadProductNotification(1);
				}
				if (this.activeTab === 'general' && isProductType !== 'product') {
					this.unshiftNewNotification(notification);
					this.increaseUnreadGeneralNotification(1);
				}
				this.ring(notification.type);
			}
		},
		update(notification) {
			const index = this.notifications.findIndex(currNotification => currNotification._id === notification._id);
			if (index !== -1) {
				this.$set(this.notifications, index, notification);
			}
		},
		ring(type) {
			if (type === 'new_payment' || type === 'new_payment_confirmation') {
				coinSound.play();
			} else if (type === 'new_withdrawal') {
				withdrawSound.play();
			} else if (type === NOTIFICATION_TYPES.BILLING_PAYMENT) {
				billingPaymentSound.play();
			} else {
				notifSound.play();
			}
			this.isRinging = true;
			delay(() => {
				this.isRinging = false;
			}, 2000);
		},
		showNotif(notif) {
			const title = NOTIFICATION_TITLES[notif.type];
			const message = getNotifMessage(notif, true);
			const link = getNotifLink(notif);
			showNotif(title, message, link);
		},
		switchTab(type) {
			this.page = 1;
			this.setActiveTab(type);
			this.fetchNotifications(true);
		},
	},
	computed: {
		...mapGetters({
			isOwner: 'isOwner',
			activeTab: 'notifications/activeTab',
			unread: 'notifications/unread',
			unreadProductCount: 'notifications/unreadProductCount',
			unreadGeneralCount: 'notifications/unreadGeneralCount',
			notificationsHeader: 'notifications/notificationsHeader',
			notifications: 'notifications/notifications',
			isFetching: 'notifications/isFetching',
		}),
		isHasUnread() {
			return this.unread > 0;
		},
		unreadDisplay() {
			return this.unread <= 99 ? this.unread : '99+';
		},
		notificationLink() {
			return this.isOwner ? '/notification-center' : '/admin/notification-center';
		},
	},
	created() {
		this.fetchNotifications();
	},
};
</script>

<style lang="scss" scoped>
	.active {
		font-weight: bold;
		color: #016dc7;
	}
	.notifications-footer {
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 30px;
		background-color: #fff;
		box-shadow: 0px -1px 10px #888888;
	}
	.unread-dot {
		position: absolute;
		width: 8px;
		height: 8px;
		margin-left: 10px;
		margin-top: 5px;
		background-color: red;
		border-radius: 50%;
	}
	.disabled-style-link {
		text-decoration: none;
	}
</style>
